import { Layout } from "@certn/cascadia-react";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsWithChildren, ReactNode } from "react";

import { UnifiedIntegrationStepHeader } from "./UnifiedIntegrationStepHeader";

interface Props extends PropsWithChildren {
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
  contentHeader?: ReactNode;
  rightSideBar?: ReactNode;
  backgroundColor?: CascadiaColor | false;
}

export function UnifiedIntegrationStepLayout(props: Props) {
  const {
    disableCompletion,
    submitting,
    onComplete,
    contentHeader,
    rightSideBar,
    backgroundColor = "surface-base",
    children,
  } = props;

  return (
    <Layout
      layout="narrow"
      backgroundColor={backgroundColor}
      header={
        <UnifiedIntegrationStepHeader
          onComplete={onComplete}
          isDisabled={disableCompletion}
          submitting={submitting}
        />
      }
      contentHeader={contentHeader}
      rightSideBar={rightSideBar}
    >
      <div className={styles.container}>{children}</div>
    </Layout>
  );
}

const styles = {
  container: css({
    display: "flex",
    justifyContent: "center",
  }),
};
